import { useRef } from 'react';
import { useIsReadOnly, useMonthlyReportStore } from '../../../store/reportStore';

const AddRequest = () => {
  const { reportMxData, setReportMxData } = useMonthlyReportStore();
  const isReadOnly = useIsReadOnly();

  const requestRef = useRef();

  /**
   * 통신란 내용을 입력하면 저장한다.
   */
  const handleAddRequest = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setReportMxData({ ...reportMxData, request: e.target.value });
  };

  return (
    <div className="row">
      <div className="panel">
        <div className="panel-heading">
          <h3>통신란</h3>
        </div>
        <div className="panel-body">
          <div className="col-xs-12 col-sm-12 col-md-12">
            <textarea
              ref={requestRef}
              className="styled-textarea" //
              value={reportMxData?.request}
              placeholder={'여기에 입력하세요'}
              onChange={handleAddRequest}
              disabled={isReadOnly}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddRequest;
